// extracted by mini-css-extract-plugin
export var dropdown = "_st-0";
export var imageWrapper = "_st-3";
export var itemNameContainer = "_st-1";
export var productImage = "_st-2";
export var spinnerWrapper = "_st-4";